import { render, staticRenderFns } from "./VReport.vue?vue&type=template&id=66498080&"
import script from "./VReport.vue?vue&type=script&lang=js&"
export * from "./VReport.vue?vue&type=script&lang=js&"
import style0 from "./VReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports